<template>
    <div>
        <publish-page view-type="learner"></publish-page>
    </div>
</template>

<script>
import PublishPage from "@/components/PublishPage"

export default {
    name: "PublishPageViewer",
    components: {
        PublishPage,
    },
}
</script>

<style></style>